/**
 * The credentials an internal v2 endpoint (`/api/v2/internal/*`) needs, for the
 * web app: the signed-in person's Firebase ID token, and this browser's `web_app`
 * Connected Device id, registering the browser first if it never was (a no-op
 * once it has). See `utils/internalApi.ts` for what internal endpoints are and
 * how a client calls one.
 */

import { auth } from '@/firebase';
import { InternalApiCredentials } from '@/utils/internalApi';
import { ensureWebClientDeviceId } from '@/utils/webClientDevice';

export { forgetWebClientDeviceIfRejected } from '@/utils/webClientDevice';

const API_BASE_URL: string = process.env.VUE_APP_API_BASE_URL || 'https://api2.rundiffusion.com/api/v2';

/**
 * Null when either cannot be had: nobody is signed in, or the registration
 * failed. Do not call an internal endpoint without them; it would only be refused.
 */
export async function internalApiCredentials (): Promise<InternalApiCredentials | null> {
	const user = auth.currentUser;
	if (!user) return null;
	const idToken: string = await user.getIdToken();
	const deviceId: string | null = await ensureWebClientDeviceId({ baseUrl: API_BASE_URL, idToken });
	return deviceId ? { idToken, deviceId } : null;
}
